import axios from 'axios';

export const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export const httpClientFormsApi = axios.create({
  baseURL: process.env.REACT_APP_FORMS_URl,
});
